import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, spacing } = theme;

export const linksBlock = css`
  margin-bottom: ${spacing.lg}px;
  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      display: block;
    `,
  )};
`;

export const title = css`
  text-align: center;
  ${theme.responsiveText.HEADING.SM}
`;

export const subHeading = css`
  margin: ${spacing.lg}px 0;
  text-align: center;
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
  ${theme.responsiveText.HEADING.XS}

  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      display: none;
    `,
  )}
`;
